import debounce from 'lodash.debounce'
import API from './services/api'

export default class Search {
  constructor() {
    this.modal = document.querySelector('[data-id="modal-search"]')

    if (this.modal) {
      this.form = this.modal.querySelector('form')
      this.input = this.modal.querySelector('input')
      this.clearBtn = this.modal.querySelector('[data-clear]')
      this.counter = this.modal.querySelector('[data-counter]')
      this.results = this.modal.querySelector('main')

      // `input` fires on every value change — typing, paste, cut, autofill,
      // drag-drop — so the live search triggers without needing a keystroke
      // (e.g. right-click → Paste). It also only fires when the value actually
      // changes, so navigation/modifier keys are ignored for free.
      this.input.addEventListener(
        'input',
        debounce(this.search.bind(this), 300)
      )
      // The form's action/tool-name markup exists so bots/agents can discover
      // the MCP search API. For humans, pressing Enter must NOT navigate to
      // that API endpoint — run the same in-page live search instead.
      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault()
          this.search()
        })
      }
      this.clearBtn.addEventListener('click', () => {
        this.reset()
      })
    }
  }

  async search() {
    const value = this.input.value.trim()
    if (value.length < 2) return

    const response = await API.search(
      new URLSearchParams({ query: this.input.value }).toString()
    )

    this.results.innerHTML = response.html
    this.clearBtn.parentNode.classList.add('has-addons')
    this.results.classList.remove('is-hidden')
    this.counter.classList.remove('is-hidden')
    this.counter.querySelector('span').innerHTML = response.count
  }

  reset() {
    this.input.value = ''
    this.input.focus()
    this.results.innerHTML = ''
    this.clearBtn.parentNode.classList.remove('has-addons')
    this.results.classList.add('is-hidden')
    this.counter.classList.add('is-hidden')
  }
}
